import React, { useState } from 'react';

const FindPumpsDropdown = ({ activeDropdown }) => {
  const [selectedCategory, setSelectedCategory] = useState('pump-selector');

  const contentData = {

    'pump-selector': [
      {
        id: 1,
        name: "Build Your Pump",
        description: "Find the right pump for your application",
        type: "service",
        link:"https://pentair.intelliquip.com/Party/application/cookieconsent/openaccesslogin?afterConsentUrl=https%3A%2F%2Fpentair.intelliquip.com%2FIEQ_HydSel%2FHydSel_JSP%2FApp%2Fstart%3FselectionRefresh%3Dtrue%26entryType%3Dselector%26returnURL%3Dhttp%253A%252F%252Fwww.aurorapump.com%26UID%3D87d62feb377be201c1e35ed59d8d70b1%26quantityItems%3D1%26isRequestFromEntryServlet%3Dyes&UID=87d62feb377be201c1e35ed59d8d70b1"
      }
    ],
    'pump-accessories': [
      {
        id: 1,
        name: "Flow - Meters",
        price: "$45",
        priceNote: "MSRP",
        image: "/images/flow-meters.png",
        badge: "",
        type: "product"
      },
      {
        id: 2,
        name: "Pressure Relief Valve",
        price: "$25",
        priceNote: "MSRP",
        image: "/images/relief-valve.png",
        badge: "",
        type: "product"
      },
      {
        id: 3,
        name: "Clean and Clear Air Relief Valve",
        price: "$300",
        priceNote: "MSRP",
        image: "/images/clean-clear.png",
        badge: "",
        type: "product"
      }
    ],

    'distributors': [
      {
        id: 1,
        name: "Find Local Dealers",
        description: "Locate authorized distributors near you",
        type: "service",
        link: "/distributors"
      }
    ],
    'request-quote': [
      {
        id: 1,
        name: "Standard Quote",
        description: "Get pricing for standard products",
        type: "service",
        link: "/contact"
      }
    ]
  };

  const categories = {
    'pump-selector': "Build Your Pump",
    'pump-accessories': "Pump Accessories",
    'distributors': "Distributors", 
    'request-quote': "Request Quote",
  };

  if (activeDropdown !== 'find-pumps') return null;

  const renderProductCard = (item) => (
    <div key={item.id} className="product-item">
      {item.badge && (
        <span className={`product-badge ${item.badge.toLowerCase()}`}>
          {item.badge}
        </span>
      )}
      
      <div className="product-image-container">
        <img 
          src={item.image} 
          alt={item.name}
          className="product-image"
        />
      </div>
      
      <div className="product-info">
        <div className="product-price-note">{item.priceNote}</div>
        <h3 className="product-title">{item.name}</h3>
        <div className="product-price">{item.price}</div>
      </div>
    </div>
  );

  const renderServiceCard = (item) => (
    <div key={item.id} className="service-card">
      <div className="service-icon">{item.icon}</div>
      <div className="service-content">
        <h3 className="service-title">{item.name}</h3>
        <p className="service-description">{item.description}</p>
        <a href={item.link} className="service-button">
          Learn More
        </a>
      </div>
    </div>
  );

  return (
    <div className="products-dropdown-overlay">
      <div className="products-dropdown-container">
        {/* Left Sidebar */}
        <div className="dropdown-sidebar">
          <ul className="category-list">
            {Object.entries(categories).map(([key, label]) => (
              <li key={key}>
                <button 
                  className={`category-item ${selectedCategory === key ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(key)}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Content */}
        <div className="dropdown-content">
          <div className="content-header">
            <h2 className="content-title">{categories[selectedCategory]}</h2>
          </div>
          
          <div className="content-grid">
            {contentData[selectedCategory]?.map((item) => 
              item.type === 'product' ? renderProductCard(item) : renderServiceCard(item)
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .content-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          justify-content: flex-start;
          max-width: 1200px;
        }

        /* Service Cards */
        .service-card {
          width: 280px;
          min-width: 280px;
          max-width: 280px;
          flex-shrink: 0;
          flex-grow: 0;
          background: white;
          border: 2px solid #e5e7eb;
          border-radius: 12px;
          padding: 2rem;
          transition: all 0.3s ease;
          cursor: pointer;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .service-card:hover {
          transform: translateY(-4px);
          border-color: #09244f;
          box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.1);
        }

        .service-icon {
          font-size: 3rem;
          margin-bottom: 1rem;
          display: block;
        }

        .service-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .service-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 0.75rem 0;
          line-height: 1.3;
        }

        .service-description {
          color: #6b7280;
          font-size: 0.95rem;
          margin: 0 0 1.5rem 0;
          line-height: 1.5;
          text-align: center;
        }

        .service-button {
          background: #09244f;
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 6px;
          font-weight: 600;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-top: auto;
          text-decoration: none;
          display: inline-block;
          text-align: center;
        }

        .service-button:hover {
          background: #061a3d;
          transform: translateY(-1px);
        }

        /* Product Cards - use existing styles but with flex sizing */
        .product-item {
          width: 280px;
          min-width: 280px;
          max-width: 280px;
          flex-shrink: 0;
          flex-grow: 0;
          position: relative;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          overflow: hidden;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .product-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border-color: #09244f;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .content-grid {
            justify-content: center;
          }
          
          .service-card,
          .product-item {
            width: 250px;
            min-width: 250px;
            max-width: 250px;
          }
        }
      `}</style>
    </div>
  );
};

export default FindPumpsDropdown;